import styled from "styled-components";

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  width: ${({ width }) => width || "80vw"};
  height: ${({ height }) => height || "80vh"};
  max-width: ${({ maxWidth }) => maxWidth || "95vw"};
  max-height: ${({ maxHeight }) => maxHeight || "95vh"};

  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #eee;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 20px;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.75;
  }
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 16px 20px;
  overflow: hidden;
`;

export const Footer = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
`;
